import { render, staticRenderFns } from "./paso7.vue?vue&type=template&id=24b69b80&"
import script from "./paso7.vue?vue&type=script&lang=ts&"
export * from "./paso7.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports